document.addEventListener("DOMContentLoaded", function () {
  let shareItemClick = ($item) => {
    console.log($item);
  };

  let addEvent = (parent, evt, selector, handler) => {
    parent.addEventListener(
      evt,
      function (event) {
        if (event.target.matches(selector + ", " + selector + " *")) {
          handler.apply(event.target.closest(selector), arguments);
        }
      },
      false
    );
  }

  let popupCenter = (url, title, w, h) => {
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }


  addEvent(document, "click", "[data-share] > a", function (e) {
    e.preventDefault();
    let $sharer = this,
      $parent = $sharer.parentNode;

    $parent.classList.toggle("open");
  });

  addEvent(document, "click", "[data-share-item]", function (e) {
    e.preventDefault();

    let $this = this,
    sn = $this.dataset.shareItem,
    title = $this.dataset.shareTitle,
    dataUrl = $this.dataset.shareUrl,
    urls = {
      facebook: 'http://www.facebook.com/share.php?u=[URL]&title=[TITLE]',
      twitter: 'http://twitter.com/intent/tweet?text=[TITLE]+[URL]',
      linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=[URL]',
      whatsapp: 'whatsapp://send?text=[TITLE]%20[URL]',
      telegram: 'https://telegram.me/share/url?url=[URL]&text=[TITLE]',
      mail: 'mailto:?subject=[TITLE]&body=[URL]',
    },
    url;

    let shareUrl = urls[sn]
    .replace('[URL]', dataUrl != '' ? encodeURIComponent(dataUrl) : encodeURIComponent(window.location))
    .replace('[TITLE]', title != '' ? encodeURIComponent(title) :  encodeURIComponent(document.title))

    if (['facebook', 'twitter', 'linkedin', 'telegram'].indexOf(sn) > -1) {
      popupCenter(shareUrl, 'share', 500, 400);
    } else {
      window.location = shareUrl;
    }
  });
});
